export default {

    // меню
    'Заявки': 'Orders',
    Заказы: 'Orders',
    'Новый заказ': 'New order',
    Архив: 'Archive',
    Отчеты: 'Reports',
    Сверка: 'Reconciliation',
    Оплата: 'Payment',
    'Оплата заявок': 'Orders payment',
    'История платежей': 'Payment history',
    'Прайс-лист': 'Price list',
    'Продление лицензий': 'License renewal',
    'Мои лицензии': 'My licenses',
    Продление: 'Renewal',
    Информация: 'Information',
    Новости: 'News',
    'О компании': 'About company',
    Договор: 'Contract',
    'Договор оферты': 'Contract offer',
    'Политика возврата': 'Refund policy',
    'Поиск по ref, номеру заявки, дате или объекту': 'Search by ref, order number, date or object',
    Настройки: 'Settings',
    Помощь: 'Help',
    Выйти: 'Logout',
    'Старая версия сайта': 'Old version of the site',
    'ООО «АВАНГАРД ТРАВЕЛ ГРУПП»': 'LLC "AVANGARD TRAVEL GROUP"',

    // заказы
    'Нет предстоящих заказов': 'No upcoming orders',
    Заявка: 'Order',
    'В обработке': 'In processing',
    'Подтврждена': 'Confirmed',
    'Лист ожидания': 'Waiting list',
    'Аннулирована': 'Cancelled',
    'Отклонена': 'Rejected',
    'Подтвержденное время:': 'Confirmed time:',
    'Вход': 'Entrance',
    'ПОДРОБНЕЕ': 'DETAILS',
    'ИЗМЕНИТЬ': 'EDIT',
    'ГДЕ СОТРУДНИК': 'WHERE IS THE EMPLOYEE',
    'АННУЛИРОВАТЬ': 'CANCEL',
    'В АРХИВ': 'TO ARCHIVE',
    'Сотрудник на объекте': 'Employee on site',
    'Сотрудник не на объекте': 'Employee not on site',
    'Но вы можете связаться с нами:': 'But you can contact us:',
    'Аннулировать': 'Cancel',
    'Хотите аннулировать заявку?': 'Do you want to cancel the order?',
    'Аннулированная заявка попадет в архив и восстановить ее будет невозможно': 'The canceled order will go to the archive and it will not be possible to restore it',
    'Отмена': 'No',
    'Дата и время:': 'Date and time:',
    'Имя гида:': 'Guide name:',
    'Не заполнено': 'Not filled',
    'Телефон гида:': 'Guide phone:',
    'Пожелания:': 'Wishes:',
    'Подтвержденное время и вход:': 'Confirmed time and entrance:',
    'Билеты:': 'Tickets:',
    'Дополнительные услуги:': 'Additional services:',
    'Причина отклонения:': 'Reason for rejection:',
    'Информация о группе:': 'Group information:',
    'Доп.услуги:': 'Additional services:',
    'Доп.информация:': 'Additional information:',

    // новый заказ
    'Информация о музее': 'Museum information',
    'Выберите категорию группы (РФ или ИГ), музей, дату и время': 'Select a group category (RF or IG), museum, date and time',
    'Выберите категорию группы': 'Select a group category',
    'Выберите музей': 'Select a museum',
    'Нет заявок за выбранный период': 'No requests for the selected period',
    'Уведомления': 'Notifications',
    'Ничего не найдено': 'Nothing found',
    'Поиск': 'Search',
    'Закрыть': 'Close',
    'Все новости': 'All news',
    'Уведомлений пока нет': 'No notifications yet',
    'В списке — только музеи, по которым у вас были заявки за выбранный период': 'Only museums where you had requests in the selected period are listed',
    'Выберите объект': 'Select an object',
    Далее: 'Next',
    'Выберите дату': 'Select a date',
    'Выберите время': 'Select a time',
    'Информация о группе': 'Group information',
    'Выберите кол-во билетов': 'Select the number of tickets',
    'Выберите страну': 'Select a country',
    Назад: 'Back',
    'Доп. услуги': 'Additional services',
    'Выберите дополнительные услуги': 'Select additional services',
    'Кол-во гидов сопровождающих (если нет лицензии)': 'Number of accompanying guides (if no license)',
    'Необходим если у гида нет лицензии в выбранный музей': 'Required if the guide does not have a license in the selected museum',
    'Доп. информация': 'Additional information',
    'Информация о гиде и пожелания': 'Guide information and wishes',
    'Ref номер (необязательно)': 'Ref number (optional)',
    'Уникальный номер группы / вспомогательный номер для ваших целей': 'Unique group number / auxiliary number for your purposes',
    'Имя гида': 'Guide name',
    'Телефон гида': 'Guide phone',
    Пожелания: 'Wishes',
    'В поле "Пожелания" укажите:': 'In the "Wishes" field, specify:',
    'адрес и время получения': 'address and time of receipt',
    'адрес и приблизительное время возврата оборудования': 'address and approximate time of return of equipment',
    Отправить: 'Send',
    'Пожалуйста, ожидайте': 'Please wait',
    Успешно: 'Successfully',
    Ошибка: 'Error',
    Ок: 'Ok',

    // архив
    'Номер заявки или ref': 'Order number or ref',
    Объект: 'Object',
    'Номер заявки': 'Order number',
    Все: 'All',
    'Дата посещения с': 'Visit date from',
    'Дата посещения по': 'Visit date to',
    Найти: 'Find',
    'Заказов согласно фильтру не найдено': 'Orders according to the filter were not found',
    'Ошибка:': 'Error:',
    'Любой номер': 'Any number',

    // сверка
    Сформировать: 'Generate',
    'Файл сверки': 'Reconciliation file',
    'Для скачивания сформированного файла сверки нажмите на конпку "Скачать".': 'To download the generated reconciliation file, click on the "Download" button.',
    'Скачать': 'Download',

    // оплата заявок
    'Оплатить заявки': 'Pay orders',
    'Для оплаты заказов введите номера ваучеров и укажите точную сумму для оплаты:': 'To pay for orders, enter the voucher numbers and specify the exact amount to pay:',
    'Номера ваучеров или заявок для оплаты (через запятую)': 'Voucher numbers or orders to pay (comma separated)',
    'Введите номера ваучеров или заявок для оплаты': 'Enter voucher numbers or orders to pay',
    'ФИО или название организации': 'Full name or organization name',
    'Введите ФИО или название организации': 'Enter full name or organization name',
    Email: 'Email',
    'Введите email': 'Enter Email',
    'Сумма к оплате': 'Amount to pay',
    'Введите сумму к оплате': 'Enter the amount to pay',
    'Согласен с договором оферты': 'I agree with the contract offer',
    'Перейти к оплате': 'Go to payment',
    'Подождите,': 'Wait,',
    'принимаем': 'receive',
    'оплату...': 'payment...',
    'Заказ успешно оплачен!': 'Order successfully paid!',
    'Ваш заказ': 'Your order',
    'успешно оплачен. Спасибо за покупку!': 'successfully paid. Thank you for your purchase!',
    'Что-то пошло не так!': 'Something went wrong!',
    'При оплате заказа': 'When paying for the order',
    'произошла ошибка!': 'an error occurred!',
    'Cчет успешно сформирован!': 'Invoice successfully generated!',
    'Вы можете открыть его нажав кнопку ниже': 'You can open it by clicking the button below',
    'Открыть счет': 'Open invoice',
    'Физическим лицам': 'Individuals',
    'Юридическим лицам': 'Legal entity',
    'Для формирования счета на оплату введите номера ваучеров или заказов, укажите реквизиты компании и точную сумму:': 'To generate an invoice for payment, enter the voucher numbers or orders, specify the company details and the exact amount:',
    'Для оплаты введите номера ваучеров или заявок и укажите точную сумму для оплаты:': 'To pay, enter the voucher numbers or orders and specify the exact amount to pay:',
    'Название организации': 'Organization name',
    'Юридический адрес': 'Legal address',
    'Сформировать счет': 'Generate invoice',

    // история платежей
    'Номер платежа': 'Payment number',
    Ваучеры: 'Vouchers',
    'Способ оплаты': 'Payment method',
    'Время и дата оплаты': 'Payment time and date',
    Сумма: 'Amount',
    Статус: 'Status',
    'Платежи отсутствуют': 'No payments',

    // прайс-лист
    'Прайс-лист для иностранных групп': 'Price list for foreign groups',
    'Актуальный файл с ценами для иностранных групп.': 'Actual file with prices for foreign groups.',
    Открыть: 'Open',
    'Прайс-лист для российских групп': 'Price list for Russian groups',
    'Актуальный файл с ценами для российских групп.': 'Actual file with prices for Russian groups.',

    // лицензии
    'Добавить лицензию': 'Add license',
    'В настоящий момент нет сохраненных лицензий, вы можете добавить их.': 'There are currently no saved licenses, you can add them.',
    'Добавить': 'Add',
    'Музей': 'Museum',
    'Номер лицензии': 'License number',
    'Стаж (лет)': 'Experience (years)',
    'Дата окончания': 'Expiration date',
    'Основной язык': 'Main language',
    'Дополнительные языки': 'Additional languages',

    // о компании
    'ИНН:7841027155': 'ИНН:7841027155',
    'КПП: 784101001': 'КПП: 784101001',
    'ОГРН: 1157847276003': 'ОГРН: 1157847276003',
    'ОКПО: 25885413': 'ОКПО: 25885413',
    'Расчетный счет: 40702810603260000188': 'Расчетный счет: 40702810603260000188',
    'Банк: Филиал "Центральный" Банка ВТБ (ПАО)': 'Банк: Филиал "Центральный" Банка ВТБ (ПАО)',
    'БИК: 044525411': 'БИК: 044525411',
    'Корр. счет: 30101810145250000411': 'Корр. счет: 30101810145250000411',
    'Юридический адрес: 191186, Санкт-Петербург г, вн.тер. г. муниципальный округ Дворцовый округ, наб Канала Грибоедова, д. 5, литера Е, помещ. Ч.ПОМ. 19-Н ОФ.405': 'Юридический адрес: 191186, Санкт-Петербург г, вн.тер. г. муниципальный округ Дворцовый округ, наб Канала Грибоедова, д. 5, литера Е, помещ. Ч.ПОМ. 19-Н ОФ.405',
    'Email: info@avangard-travel.ru': 'Email: info@avangard-travel.ru',
    'Телефон: (812) 640-02-28': 'Phone: (812) 640-02-28',

    // договор
    'Вы можете посмотреть договор с ООО "Авангард Травел Групп".': 'You can view the contract with Avangard Travel Group LLC.',

    // договор оферты
    'Вы можете посмотреть договор оферты с ООО "Авангард Травел Групп".': 'You can view the contract offer with Avangard Travel Group LLC.',

    // политика возврата
    'Вы можете посмотреть политику возврата.': 'You can view the refund policy.',

    // настройки
    'Имя:': 'Name:',
    'Телефон:': 'Phone:',
    'Страна:': 'Country:',
    'Информация о гиде': 'Guide information',
    'Заполните информацию и подавайте заявки еще быстрее': 'Fill in the information and submit applications even faster',
    Имя: 'Name',
    Телефон: 'Phone',
    'Выберите страницу': 'Select a country',
    'Использовать в заказе?': 'Use in order?',
    Сохранить: 'Save',
    'Являетесь ли вы туристической фирмой / юридическим лицом': 'Are you a travel agency / legal entity',
    'Юридическое лицо': 'Legal entity',
    'Для выставления счетов': 'For invoicing',

    // форма логина
    Логин: 'Login',
    Пароль: 'Password',
    Войти: 'Login',
    'Выберите язык': 'Select language',

    // уведомление
    'Теперь можно оплатить заявки онлайн, включая оплату от юридических лиц!': 'Now you can pay for applications online, including payment from legal entities!',
    'Мы рады сообщить, что теперь вы можете оплатить заявки на нашем сайте, используя банковскую карту или QR-код системы быстрых платежей. Вдобавок к этому, мы расширили наши возможности и теперь доступна оплата и для юридических лиц. Юридические лица могут самостоятельно генерировать счета для оплаты.': 'We are pleased to announce that now you can pay for applications on our website using a bank card or QR code of the fast payment system. In addition to this, we have expanded our capabilities and now payment is also available for legal entities. Legal entities can independently generate invoices for payment.',
    'Никаких задержек и лишних хлопот - оплата проходит мгновенно. Перейдите в раздел "Оплата заявок" и оплачивайте свои заявки быстро и удобно! Наши новые возможности сделают процесс ещё более удобным и эффективным.': 'No delays and unnecessary hassle - payment is instant. Go to the "Payments" section and pay for your applications quickly and conveniently! Our new features will make the process even more convenient and efficient.',

    // помощь
    'У вас есть вопросы?': 'Do you have any questions?',
    'Если вы не можете найти ответ на вопрос, вы всегда можете связаться с нами. Мы ответим вам в ближайшее время!': 'If you cannot find the answer to your question, you can always contact us. We will answer you as soon as possible!',
    'Мы всегда рады помочь!': 'We are always happy to help!',
    'Лучший способ получить ответ быстрее!': 'The best way to get an answer faster!',
    'Мы используем файлы cookie, чтобы сайт работал и был удобнее. Оставаясь на сайте, вы соглашаетесь на их использование.': 'We use cookies to keep the site working and more convenient. By staying on the site, you agree to their use.',
    'Хорошо': 'Got it',
    'Подача графика на {month} закрывается {deadline}.': 'Schedule submission for {month} closes on {deadline}.',
    'Россия': 'Russia',

    // оплата лицензий
    'Оплата продления': 'Renewal payment',
    'Оплатить': 'Pay',
    'К заказам': 'To orders',
    'Повторить': 'Try again',
    'Выбор лицензий': 'Choose licenses',
    'Выберите одну или несколько лицензий для оплаты': 'Select one or more licenses to pay for',
    'Сезон продления: приём заявок с {start} по {finish}': 'Renewal season: applications accepted from {start} to {finish}',
    'Выберите лицензии': 'Select licenses',
    'Нет лицензий для оплаты': 'No licenses to pay for',
    'Итого к оплате': 'Total to pay',
    'Плательщик': 'Payer',
    'ФИО и email, на который придёт чек': 'Full name and the email the receipt will be sent to',
    'Проверьте список лицензий и перейдите к оплате': 'Check the list of licenses and proceed to payment',
    'Лицензия № {no}': 'License No. {no}',
    'После оплаты менеджер получит уведомление и отметит оплату. Чек придёт на указанный email.': 'After payment the manager is notified and marks the payment. The receipt will be sent to the email you entered.',
    'Продление уже оплачено': 'Renewal already paid',
    'Оплачено на сайте, ждёт подтверждения менеджера': 'Paid on the site, awaiting manager confirmation',
    'Оплата лицензий пока недоступна.': 'License payment is not available yet.',
    'Цены на лицензии ещё не опубликованы. Попробуйте позже или свяжитесь с менеджером.': 'License prices have not been published yet. Try again later or contact the manager.',
    'Не удалось получить список лицензий. Попробуйте ещё раз.': 'Could not load the list of licenses. Please try again.',
    'Не удалось создать счёт на оплату. Попробуйте ещё раз.': 'Could not create the payment invoice. Please try again.',
    'Список лицензий или цены изменились. Обновите страницу и выберите лицензии заново.': 'The list of licenses or the prices have changed. Refresh the page and select the licenses again.',
    'Введите ваш email': 'Enter your email',
    'Продление этой лицензии сейчас закрыто': 'Renewal of this license is currently closed',
    'Укажите язык лицензии в разделе «Мои лицензии»': 'Specify the license language in the “My licenses” section',
    'Заявка на продление подана': 'Renewal application submitted',
    'Заявка на продление будет подана автоматически': 'The renewal application will be submitted automatically',
    'Заявку на продление оформит менеджер': 'The manager will file the renewal application',
    'Добавьте свои лицензии в раздел «Мои лицензии», и заявки на продление будут подаваться автоматически.': 'Add your licenses to the “My licenses” section and renewal applications will be submitted automatically.',
    'Консультационные услуги (лицензии)': 'Consulting services (licenses)',
    'Продление или первичное получение, затем музей': 'Renewal or first-time licensing, then the museum',
    'Первичное получение': 'First-time licensing',
    'первичное получение': 'first-time licensing',
    'Оплата в офисе': 'Paid at the office',
    'Итого к оплате на сайте': 'Total to pay online',
    'ФИО для договора, телефон и email, на который придёт чек': 'Full name for the contract, phone and the email the receipt will be sent to',
    'ФИО': 'Full name',
    'Фамилия Имя Отчество': 'Last name, first name, patronymic',
    'Введите ФИО полностью': 'Enter your full name',
    'Контактный телефон': 'Contact phone',
    'Введите корректный телефон': 'Enter a valid phone number',
    'Договор и оплата': 'Contract and payment',
    'Проверьте список, подтвердите договор и перейдите к оплате': 'Check the list, confirm the contract and proceed to payment',
    'Заявки на продление поданы.': 'Renewal applications have been submitted.',
    'Оплата этих лицензий производится в офисе. Для справок свяжитесь с менеджером по телефону {phone}.': 'These licenses are paid for at the office. For details, call the manager at {phone}.',
    'Договор оказания услуг': 'Service agreement',
    'Не удалось получить текст договора. Попробуйте ещё раз.': 'Could not load the contract text. Please try again.',
    'Я принимаю условия договора возмездного оказания услуг': 'I accept the terms of the paid services agreement',
    'Подать заявки': 'Submit applications',
    'Выбор группы откроется после оплаты продления.': 'Group selection opens after the renewal is paid.',
    'Оплатить продление': 'Pay for the renewal',
    'Продление оплачено на сайте.': 'The renewal has been paid on the site.',
    'Не удалось записаться в группу. Попробуйте ещё раз.': 'Could not join the group. Please try again.',
    'Выбрать группу': 'Choose a group',
    'Теперь можно выбрать группу для занятий: она появится в карточке музея на странице «Продление», как только менеджер назначит даты.': 'You can now choose a group for the sessions: it appears in the museum card on the “Renewal” page as soon as the manager sets the dates.',
    'Тестовый режим': 'Test mode',
    'Раздел проверяется, оплачивать лицензии через сайт пока не нужно.': 'This section is being tested. There is no need to pay for licenses on the site yet.',
    'истекла': 'expired',
    'Не удалось удалить лицензию. Попробуйте ещё раз.': 'Could not delete the license. Please try again.',
    'Не удалось добавить лицензию. Попробуйте ещё раз.': 'Could not add the license. Please try again.',
    'Расписание занятий': 'Session schedule',
    'Расписание занятий пока не опубликовано.': 'The session schedule has not been published yet.',
    'Расписание занятий появится после записи.': 'The session schedule will appear after you sign up.',
    'Стоимость занятий': 'Session price',
    'Записаться на продление': 'Sign up for renewal',
    'Оплатить занятия': 'Pay for sessions',
    'Выбрать дату занятий': 'Choose a session date',
    'Подать заявку на продление: {museum}? После этого станет видно расписание занятий.': 'Submit a renewal request: {museum}? The session schedule will become visible after that.',
    'Продление по этому музею сейчас закрыто.': 'Renewal for this museum is currently closed.',
    'Укажите в лицензии язык: без него заявку не принять. Это можно сделать через «Изменить».': 'Please specify a language in the license: the request cannot be accepted without it. You can do this via “Изменить”.',
    'Лицензия продлена.': 'The license has been renewed.',
    'Заявка на продление подана.': 'The renewal request has been submitted.',
    'Занятия оплачены.': 'The sessions have been paid for.',
    'Занятия оплачены на сайте, менеджер подтвердит оплату.': 'The sessions have been paid for on the site; the manager will confirm the payment.',
    'Вы записаны на занятия: {group}.': 'You are signed up for sessions: {group}.',
    'Не удалось подать заявку. Попробуйте ещё раз.': 'Could not submit the request. Please try again.',
    'Занятия оплачены. Выберите дату занятий в карточке: {museums}.': 'The sessions are paid for. Choose a session date in the card: {museums}.',
    'Укажите язык лицензии на странице «Продление лицензий»': 'Specify the license language on the “License renewal” page',
    'Сначала добавьте лицензию на странице «Продление лицензий»': 'First add the licence on the «Licence renewal» page',
    'Оплата возвращена, можно оплатить заново': 'Payment refunded, you can pay again',
    'свободно {free} из {limit}': '{free} of {limit} places free',
    'мест нет': 'no places left',
    'Добавьте свои лицензии на странице «Продление лицензий», и заявки на продление будут подаваться автоматически.': 'Add your licenses on the “License renewal” page, and renewal requests will be submitted automatically.',
    'Теперь можно выбрать дату занятий по расписанию: откройте карточку лицензии на странице «Продление лицензий».': 'You can now choose a session date from the schedule: open the license card on the “License renewal” page.',
    'Лицензии': 'Licenses',
    'Подать заявку': 'Submit a request',
    'Выбрать': 'Choose',
    'Стоимость пока не указана.': 'The price has not been set yet.',
    'Лицензии на этот музей нет в кабинете. Добавьте её, чтобы записаться на продление и оплатить занятия.': 'There is no license for this museum in your account. Add it to sign up for renewal and pay for the sessions.',
    'Музеи, где у вас нет лицензии': 'Museums where you have no license',
    'С окончания срока действия лицензии прошло 3 года. Просьба обратиться к менеджеру за консультацией.': 'Three years have passed since the license expired. Please contact the manager for a consultation.',
    'Прошло три года после окончания лицензии — нужно первичное обучение': 'Expired over three years ago — initial training only',
    'Просим вас вписать ФИО полностью и кириллицей: это нужно для соблюдения законодательства РФ.': 'Please enter your full name in Cyrillic (Russian letters): this is required by Russian law.',
    'Введите ФИО кириллицей — допустимы только буквы, пробел и дефис': 'Enter your full name in Cyrillic — only letters, spaces and hyphens are allowed',
    'Оплатите занятия и после этого выберите дату и время.': 'Pay for the classes, then choose the date and time.',
    'Выбрать дату и время занятий можно будет после подтверждения менеджера.': 'You will be able to choose the date and time of the classes after the manager confirms.',
    'Поиск по лицензиям': 'Search licenses',
    'Музей или номер лицензии': 'Museum or license number',
    'Договоры оказания услуг': 'Service agreements',
    'Договор на продление': 'Renewal agreement',
    'Договор на первичное обучение': 'Initial training agreement',
    'Я принимаю условия договоров возмездного оказания услуг': 'I accept the terms of the paid services agreements',
    'Email:': 'Email:',
    'После оплаты договор сохранится в «Настройках» и в «Истории платежей»: его можно открыть и скачать в PDF.': 'After payment the contract is kept in “Settings” and “Payment history”: you can open it and download it as PDF.',
    'После оплаты договоры сохранятся в «Настройках» и в «Истории платежей»: их можно открыть и скачать в PDF.': 'After payment the contracts are kept in “Settings” and “Payment history”: you can open them and download them as PDF.',
    'Договоры оказания услуг, которые вы подписали при оплате лицензий. Их можно открыть и скачать в любой момент.': 'Service contracts you signed when paying for licenses. You can open and download them at any time.',
    'от {date}, платёж № {payment}': 'dated {date}, payment No. {payment}',
    'оплата возвращена': 'payment refunded',
    'Скачать PDF': 'Download PDF',
    'Вы согласились с условиями договора и подписали его {date} в {time}, отметив «{label}».': 'You agreed to the terms of the contract and signed it on {date} at {time} by ticking “{label}”.',
    'Не удалось получить договор. Попробуйте ещё раз.': 'Could not load the contract. Please try again.',

    // получение лицензий (правка начальника 02.10.2026)
    'Получение лицензий': 'Obtaining licenses',
    'Можно оплатить': 'Ready to pay',
    'Отметьте музеи и отправьте заявку.': 'Tick the museums and send a request.',
    'Дождитесь даты обучения — она появится здесь.': 'Wait for the training date — it will appear here.',
    'Выберите дату и оплатите обучение.': 'Choose a date and pay for the training.',
    'Приём заявок с {start} по {finish}': 'Requests are accepted from {start} to {finish}',
    'Получение лицензий сейчас недоступно.': 'Obtaining licenses is not available right now.',
    'Мои заявки': 'My requests',
    'Новая заявка': 'New request',
    'Стоимость обучения': 'Training price',
    'Приём заявок сейчас закрыт.': 'Requests are not being accepted right now.',
    'Отправить заявку': 'Send request',
    'Заявка отправлена: {museums}. Когда появится дата обучения, вы сможете выбрать её и оплатить.': 'Request sent: {museums}. When a training date appears, you will be able to choose it and pay.',
    'Заявки отправлены: {museums}. Когда появится дата обучения, вы сможете выбрать её и оплатить.': 'Requests sent: {museums}. When a training date appears, you will be able to choose it and pay.',
    'Заявка отправлена: {museums}. Дата обучения уже есть — выберите её в «Моих заявках» и оплатите.': 'Request sent: {museums}. A training date is already available — choose it under “My requests” and pay.',
    'Заявки отправлены: {museums}. Дата обучения уже есть — выберите её в «Моих заявках» и оплатите.': 'Requests sent: {museums}. A training date is already available — choose it under “My requests” and pay.',
    'Не удалось получить список заявок. Попробуйте ещё раз.': 'Could not load the list of requests. Please try again.',
    'Язык: {langs}': 'Language: {langs}',
    'Языки: {langs}': 'Languages: {langs}',
    'Заявка подана. Дата обучения пока не назначена. Когда она появится, вы сможете выбрать дату и оплатить обучение.': 'The request has been submitted. No training date has been set yet. When it appears, you will be able to choose a date and pay for the training.',
    'Заявка подана. Выберите дату обучения и оплатите.': 'The request has been submitted. Choose a training date and pay.',
    'Заявка подана. Дата обучения: {group}.': 'The request has been submitted. Training date: {group}.',
    'Заявка подана.': 'The request has been submitted.',
    'Дата обучения': 'Training date',
    'Дата обучения: {group}': 'Training date: {group}',
    'Даты обучения': 'Training dates',
    'Оплата этого обучения производится в офисе. Для справок свяжитесь с менеджером по телефону {phone}.': 'This training is paid for at the office. For details, call the manager at {phone}.',
    'Заявка подана. Стоимость обучения пока не указана — оплата откроется позже.': 'The request has been submitted. The training price has not been set yet — payment will open later.',
    'Обучение оплачено. Записываем вас на {date}. Если запись не появится — позвоните менеджеру: {phone}.': 'The training has been paid for. We are signing you up for {date}. If the booking does not appear, call the manager: {phone}.',
    'Обучение оплачено.': 'The training has been paid for.',
    'Обучение оплачено. Дату обучения сообщит менеджер.': 'The training has been paid for. The manager will tell you the training date.',
    'Записать вас на {date} не получилось: {reason}': 'We could not sign you up for {date}: {reason}',
    'Выберите другую дату.': 'Choose another date.',
    'Дату обучения сообщит менеджер: {phone}.': 'The manager will tell you the training date: {phone}.',
    'Обучение оплачено. Вы записаны: {group}.': 'The training has been paid for. You are signed up: {group}.',
    'Обучение пройдено.': 'The training has been completed.',
    'Лицензия № {no}, действует до {date}.': 'License No. {no}, valid until {date}.',
    'Оплата на сайте пока недоступна. Свяжитесь с менеджером: {phone}.': 'Online payment is not available yet. Contact the manager: {phone}.',
    'Изменить языки или отменить заявку можно через менеджера: {phone}.': 'To change the languages or cancel the request, contact the manager: {phone}.',
    'Место в группе закрепляется после оплаты.': 'Your place in the group is secured after payment.',
    'Выбрать дату': 'Choose a date',
    'Оплата обучения': 'Training payment',
    'Получаете лицензию впервые?': 'Getting a license for the first time?',
    'Вам в раздел «Получение лицензий»': 'Go to the “Obtaining licenses” section',
    'К заявкам': 'To requests',
    'Обучение и дата': 'Training and date',
    'Музей и дата обучения': 'Museum and training date',
    'Музеи, по которым продлеваете лицензию': 'Museums whose licenses you are renewing',
    'Оплата обучения на сайте пока недоступна.': 'Online payment for training is not available yet.',
    'Оплачивать пока нечего. Оплата откроется после заявки, когда появится дата обучения.': 'There is nothing to pay for yet. Payment opens after you submit a request and a training date appears.',
    'Дата обучения ещё не назначена': 'No training date has been set yet',
    'Выбранная дата обучения больше недоступна. Выберите дату заново.': 'The selected training date is no longer available. Please choose a date again.',
    'Обучение оплачено. Запись на выбранную дату появится на странице «Получение лицензий».': 'The training has been paid for. Your booking for the chosen date will appear on the “Obtaining licenses” page.',
    'К моим заявкам': 'To my requests',
    'К оплате продления': 'To renewal payment',
    'Появилась дата обучения: {museums}. Можно выбрать дату и оплатить.': 'A training date is available: {museums}. You can choose a date and pay.',
    'Обучение оплачено, выберите дату: {museums}.': 'The training has been paid for, choose a date: {museums}.',
    'Перейти': 'Open',
    'Перейти к получению лицензии': 'Go to obtaining a license',
    'Не удалось получить список языков.': 'Could not load the list of languages.',
    'Дата обучения прошла.': 'The training date has passed.',
    'Лицензия по этому музею у вас уже есть. Обратитесь к менеджеру.': 'You already have a licence for this museum. Please contact the manager.',
    'Заявки отправлены: {museums}. Дата обучения уже есть: {dated} — выберите её в «Моих заявках» и оплатите.': 'Requests sent: {museums}. A training date is already available for: {dated} — choose it under “My requests” and pay.',
    'Выберите дату обучения по каждому музею.': 'Choose a training date for each museum.',
    'Система заявок сейчас не отвечает. Попробуйте через минуту.': 'The request system is not responding right now. Please try again in a minute.',
    'Подтвердите договор оказания услуг.': 'Please confirm the service agreement.',
    'Лицензия не указана.': 'No licence specified.',
    'Лицензия не найдена.': 'Licence not found.',
    'Выберите хотя бы одну лицензию.': 'Select at least one licence.',
    'Введите ФИО кириллицей — допустимы только буквы, пробел и дефис.': 'Enter the full name in Cyrillic — only letters, spaces and hyphens are allowed.',
    'Не выбран музей.': 'No museum selected.',
    'Выберите язык: без него заявку на обучение не примут.': 'Choose a language: a training request cannot be accepted without it.',
    'Так записаться можно только на первичное обучение.': 'This way you can only sign up for initial training.',
    'Выбор даты откроется после оплаты обучения.': 'Date selection opens after the training is paid.',
    'Введите ФИО полностью.': 'Enter your full name.',
    'Введите корректный телефон.': 'Enter a valid phone number.',
    'Введите корректный email.': 'Enter a valid email.',
    'Система заявок отклонила запрос. Попробуйте ещё раз или свяжитесь с оператором.': 'The request system rejected the request. Please try again or contact the operator.',
    'Первичное получение, продление': 'Initial licensing, renewal',
    'Мои договоры': 'My agreements',
    'Подписанных договоров пока нет. Они появятся здесь после оплаты продления или обучения на сайте.': 'No signed agreements yet. They will appear here after you pay for renewal or training on the site.',
    'Здесь можно заказать технические средства ведения экскурсий': 'Here you can order technical equipment for guided tours',

    // Прайс-лист с ценами (09.10.2026)
    'Ваши цены': 'Your prices',
    'Персональный прайс-лист': 'Personal price list',
    'Общий прайс-лист': 'General price list',
    'действует с': 'valid from',
    'Объект': 'Object',
    'Основная цена': 'Standard price',
    'Льготная цена': 'Reduced price',
    'Стоимость по прайс-листу:': 'Price list cost:',
    'без учёта:': 'excluding:',

    // Прайс-листы по категориям групп (12.10.2026)
    'Российские туристы': 'Russian tourists',
    'Иностранные туристы': 'Foreign tourists',
    'Китайские туристы': 'Chinese tourists',
    'Школьная группа': 'School group',
    'Школьные группы': 'School groups',
    'Основная': 'Standard',
    'Льготная': 'Reduced',
    'За группу': 'Per group',
    'Группа до {n} чел.': 'Group up to {n} people',
    'Экскурсионное обслуживание': 'Guided tour service',
    'Обслуживание до {n} чел.': 'Service, group up to {n} people',
    'Группа': 'Group',
    'ЭО': 'Guide',
    'Экскурсионное обслуживание, за одно': 'Guided tour service, each',
    'экскурсионное обслуживание': 'guided tour service',
    'VIP': 'VIP',
    'за группу': 'per group',
    'Нажмите на заголовок, чтобы раскрыть цены, на название музея — его объекты': 'Click the heading to show prices, a museum name to show its objects',
    'ШКОЛЬНАЯ': 'SCHOOL',
    'Цена за группу': 'Group price',
    'до {n} чел.': 'up to {n} people',
    'Услуги в заявке в музей': 'Services in a museum order',
    'за человека': 'per person',
    'за доставку': 'per delivery',
    'Калькулятор цен': 'Price calculator',
    'Выберите музей, объект и количество билетов — стоимость посчитается по вашему прайс-листу': 'Select a museum, an object and the number of tickets — the cost is calculated by your price list',
    'Дата нужна, чтобы взять прайс-лист, действующий на день посещения': 'The date selects the price list valid on the day of the visit',
    'При группе от {n} человек требуется радиогид': 'Groups of {n} or more people require a radio guide',
    'Стоимость': 'Cost',
    'Выберите музей и объект — расчёт появится здесь': 'Select a museum and an object — the calculation will appear here',
    'Укажите количество билетов': 'Enter the number of tickets',
    'Считаем…': 'Calculating…',
    'Для этого объекта цены в прайс-листе нет. Сумму рассчитает менеджер после подачи заявки.': 'There is no price for this object in the price list. The manager will calculate the amount after the order is submitted.',
    'Расчёт недоступен: войдите в кабинет заново': 'Calculation is unavailable: please sign in again',
    'Итого': 'Total',
    'У этих услуг нет цены в прайс-листе — её уточнит менеджер.': 'These services have no price in the price list — the manager will specify it.',
    'Основные билеты': 'Full-price tickets',
    'Льготные билеты': 'Reduced-price tickets',
    '{n} чел.': '{n} people',
    'Хотите рассчитать цену?': 'Want to calculate the price?',
    'Воспользуйтесь нашим калькулятором: выберите музей, объект и количество билетов — сумма посчитается по вашему прайс-листу.': 'Use our calculator: select a museum, an object and the number of tickets — the amount is calculated by your price list.',
    'Открыть калькулятор': 'Open the calculator',
    'Аудиогид': 'Audio guide',
    'Изменить номер': 'Change number',
    'Изменить номер лицензии': 'Change the licence number',
    'Не удалось изменить номер лицензии. Попробуйте ещё раз.': 'Could not change the licence number. Please try again.',
    'Добавить группу': 'Add group',
    'Расчёт по группам': 'Calculation by groups',
    'Музеев в расчёте': 'Museums in the calculation',
    'Итого по всем группам': 'Total for all groups',
    'Очистить расчёт': 'Clear the calculation',
    'Группа добавлена в расчёт. Выберите следующий музей — количество билетов подставится прежнее.': 'The group has been added to the calculation. Select the next museum — the ticket counts will be carried over.',
    'чел.': 'people',
    'Убрать': 'Remove',
    'Вместе с добавленными группами ({n})': 'Together with the added groups ({n})',
    'Расчёт стоимости': 'Cost calculation',
    'Заголовок документа': 'Document title',
    'Не удалось подготовить файл. Попробуйте ещё раз.': 'Could not prepare the file. Please try again.',
    'доставка': 'delivery',
    'Скачать расчёт': 'Download the calculation',
    'новое': 'new',
    'Подача заявок по расчёту': 'Submitting requests from the calculation',
    'На каждый музей уйдёт отдельная заявка. Выберите время посещения и укажите данные гида.': 'A separate request goes to each museum. Choose the visit time and enter the guide details.',
    'На эту дату записи нет — измените дату в калькуляторе': 'No time slots on this date — change the date in the calculator',
    'выберите время': 'choose a time',
    'это время больше недоступно, выберите другое': 'this time is no longer available, choose another',
    'Отправлено заявок: {n}': 'Requests sent: {n}',
    'Причина': 'Reason',
    'До сбоя в офис успели уйти заявки {list} — они уже в «Заказах», подавать их заново не нужно.': 'Requests {list} reached the office before the failure — they are already in "Orders", do not submit them again.',
    'Остальные музеи оставлены в расчёте — исправьте и отправьте заново.': 'The remaining museums are kept in the calculation — fix and send again.',
    'Заявка не отправлена': 'The request was not sent',
    'Заявка на эту дату не принимается: не раньше чем за {n} дн. — измените дату в калькуляторе': 'Requests for this date are not accepted: at least {n} days in advance — change the date in the calculator',

    // Калькулятор стоимости лицензий и выбор калькулятора (27.10.2026).
    'Билеты, экскурсионное обслуживание и услуги по вашему прайс-листу. Расчёт можно скачать и сразу подать заявку.': 'Tickets, guided tours and services according to your price list. You can download the calculation and submit a request right away.',
    'Выберите, что посчитать': 'Choose what to calculate',
    'Из них оплачивается в офисе': 'Of which paid at the office',
    'К выбору калькулятора': 'Back to calculator choice',
    'К получению лицензий': 'To licence obtaining',
    'Расчёт стоимости заявки': 'Request cost calculation',
    'Расчёт стоимости лицензий': 'Licence cost calculation',
    'Не удалось получить цены. Попробуйте ещё раз.': 'Could not get the prices. Please try again.',
    'Оплачивается в офисе': 'Paid at the office',
    'Отметьте музеи слева — здесь появится расчёт.': 'Tick the museums on the left — the calculation will appear here.',
    'Отметьте музеи — стоимость посчитается по ценам текущего сезона': 'Tick the museums — the cost is calculated at the current season prices',
    'Очистить': 'Clear',
    'Первичное получение (обучение)': 'Initial obtaining (training)',
    'Продление и получение лицензий по ценам текущего сезона. Расчёт можно скачать и перейти к оплате.': 'Licence renewal and obtaining at the current season prices. You can download the calculation and proceed to payment.',
    'Продление лицензии': 'Licence renewal',
    'Сезон': 'Season',
    'Цены на этот сезон пока не заведены. Уточните стоимость по телефону {phone}.': 'Prices for this season are not set yet. Please check the cost by phone {phone}.',
    'лицензий: {n}': 'licences: {n}',
    'Цены на сезон пока нет — уточните по телефону {phone}.': 'No season price yet — please check by phone {phone}.',

    // Договор при отметке «Согласие» (28.10.2026).
    'Вы согласились с условиями договора и подписали его {date} в {time}, нажав «Согласие».': 'You agreed to the terms of the contract and signed it on {date} at {time} by ticking "Consent".',
    'Договор подписан и сохранён в «Настройках».': 'The contract is signed and saved in "Settings".',
    'Договоры оказания услуг, которые вы подписали отметкой «Согласие» при оплате лицензий. Их можно открыть и скачать в любой момент.': 'Service contracts you signed by ticking "Consent" when paying for licences. You can open and download them at any time.',
    'Договоры подписаны и сохранены в «Настройках».': 'The contracts are signed and saved in "Settings".',
    'Не удалось сохранить договор. Попробуйте ещё раз.': 'Could not save the contract. Please try again.',
    'Подписанных договоров пока нет. Они появятся здесь, как только вы отметите «Согласие» на шаге оплаты продления или обучения.': 'No signed contracts yet. They will appear here as soon as you tick "Consent" at the payment step for renewal or training.',
    'После отметки «Согласие» договор сохранится в «Настройках»: его можно открыть и скачать в PDF в любой момент.': 'Once you tick "Consent", the contract is saved in "Settings": you can open it and download the PDF at any time.',
    'После отметки «Согласие» договоры сохранятся в «Настройках»: их можно открыть и скачать в PDF в любой момент.': 'Once you tick "Consent", the contracts are saved in "Settings": you can open them and download the PDFs at any time.',
    'Согласие: я принимаю условия договора возмездного оказания услуг': 'Consent: I accept the terms of the paid services contract',
    'Согласие: я принимаю условия договоров возмездного оказания услуг': 'Consent: I accept the terms of the paid services contracts',
    'Сохраняем договор…': 'Saving the contract…',
    'ожидает оплаты': 'awaiting payment',
    'от {date}': 'dated {date}',

    // Расчёт стоимости: радиогид/аудиогид, итоги в множественных заявках (30.10.2026)
    'Что считаем': 'What to calculate',
    'Заявка в музей': 'Museum request',
    'Радиогид в город': 'Radio guide in the city',
    'Радиогид в музей': 'Radio guide in a museum',
    'Выберите музей — расчёт появится здесь': 'Select a museum — the calculation will appear here',
    'Укажите количество аппаратов': 'Enter the number of devices',
    'Для этой услуги цены в прайс-листе нет. Сумму рассчитает менеджер после подачи заказа.': 'There is no price for this service in the price list. The manager will calculate the amount after the order is placed.',
    'Заказать радиогид / аудиогид': 'Order a radio / audio guide',
    'В расчёте есть заказ радиогида или аудиогида: такие заказы подаются в разделе «Радиогид / Аудиогид», заявки в музеи — из расчёта без него.': 'The calculation includes a radio or audio guide order: such orders are placed in the “Radio / Audio guides” section; museum requests are submitted from a calculation without it.',
    'Доставка': 'Delivery',
    'за пределами КАД': 'outside the ring road',
    'в пределах КАД': 'within the ring road',
    'доставка в пределах КАД': 'delivery within the ring road',
    'Аппараты': 'Devices',
    'аппараты': 'devices',
    'Заказ добавлен в расчёт.': 'The order has been added to the calculation.',
    'оценено музеев: {n} из {total}': 'museums priced: {n} of {total}',
    'оценено групп: {n} из {total}': 'groups priced: {n} of {total}',
    'Кол-во аппаратов': 'Number of devices',
    'Оформить доставку (услуга платная)': 'Order delivery (paid service)',
    'Доставка в пределах КАД': 'Delivery within the ring road',
    'Доставка за пределы КАД': 'Delivery outside the ring road',
}
